import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchActivities } from "src/redux/slices/activities";
import { SITE_IMAGES, veilGradient } from "src/config/images";
import RequestCta from "src/sections/components/request-cta";
import { TourSection } from "./components/tour-section";

const Activities = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const activities = useSelector((state) => state.activities.activities.items);

  useEffect(() => {
    dispatch(fetchActivities());
  }, [dispatch]);

  const list = activities || [];
  // Hot tours = have a confirmed date; regular tours = no date set.
  // Ограничения по количеству нет — лента едет по кругу и показывает все туры.
  const hot = list.filter((a) => a?.date);
  const regular = list.filter((a) => !a?.date);

  return (
    // pt меньше pb: сверху секцию уже отделяет разделитель, и лишний отступ
    // только растягивал тёмный проём между первым экраном и турами.
    <section id="activities" className="relative w-full pt-4 sm:pt-6 pb-12 sm:pb-16">
      {/* Фоновое фото секции туров — меняется в src/config/images.js (ключ activities).
          Фото стоит полосой сверху и плавно уходит в тёмный фон страницы. */}
      <div className="absolute inset-x-0 top-0 h-[440px] sm:h-[560px] overflow-hidden photo-fade-both">
        <img
          src={SITE_IMAGES.activities}
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover"
        />
        {/* Затемнение: сильнее по краям, слабее в середине — там видно фото.
            Плотность общая для всего сайта, см. PHOTO_VEIL в config/images.js */}
        <div className="absolute inset-0" style={{ backgroundImage: veilGradient() }} />
      </div>

      <div className="relative z-10 max-w-[1526px] w-full mx-auto px-4 flex flex-col gap-y-12 sm:gap-y-14">
        <div>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between sm:gap-4">
            <div>
              <h3 className="text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-kj-ink">
                {t("activities.hotTitle")}
              </h3>
              <p className="mt-2 text-base text-kj-sub max-w-2xl leading-relaxed">
                {t("activities.hotSubtitle")}
              </p>
            </div>
            <button
              onClick={() => navigate("/activities")}
              className="self-start sm:self-auto flex-shrink-0 rounded-md border border-kj-sky/40 px-4 py-2 text-xs sm:text-sm font-bold uppercase tracking-[0.12em] text-kj-sky hover:bg-kj-sky hover:text-kj-dark transition-colors"
            >
              {t("activities.buttonText")} →
            </button>
          </div>
          {hot.length > 0 ? (
            <TourSection tours={hot} layout="scroll" />
          ) : (
            <p className="mt-6 text-base text-kj-sub max-w-2xl leading-relaxed">
              {t("activities.hotEmpty")}
            </p>
          )}
        </div>

        <TourSection
          title={t("activities.regularTitle")}
          subtitle={t("activities.regularSubtitle")}
          tours={regular}
          layout="scroll"
        />

        <RequestCta />
      </div>
    </section>
  );
};

export default Activities;
